import type { IContributionProjetRepository } from '../../domain/ports/IContributionProjetRepository';
import type { ContributionProjetDTO, ModifierContributionInput } from '../dto/dtos';

export interface ModifierContributionUseCaseInput {
  idContribution: string;
  data: ModifierContributionInput;
}
export interface ModifierContributionOutput { contribution: ContributionProjetDTO; }

export class ModifierContributionUseCase {
  constructor(private readonly repository: IContributionProjetRepository) {}

  async execute(input: ModifierContributionUseCaseInput): Promise<ModifierContributionOutput> {
    const response = await this.repository.modifier(input.idContribution, input.data);
    if (!response.succes || !response.data) throw new Error(response.message || 'Erreur lors de la modification');
    return { contribution: response.data };
  }
}
